<template>
    <div v-if="breadcrumbs.length > 1">
        <v-container class="py-0 pl-lg-0 px-3">
            <swiper
                slides-per-view="auto"
                free-mode
                class="py-4"
            >
                <swiper-slide v-for="(item, index) in breadcrumbs" :key="index"
                              class="text-body-2 bg-transparent w-auto d-inline-flex align-center">
                            <template v-if="index + 1 === breadcrumbs.length">
                                <span :class="white ? 'text-white' : 'text-grey'" v-bind="props">{{ item.title }}</span>
                            </template>
                            <template v-else>
                                <Link :href="item.url" class="d-inline-flex align-center cursor-pointer" v-bind="props"
                                      :class="[item.disabled ? 'text-grey' : 'text-orange']">
                                    <v-icon v-if="item.url === '/'" id="homepage-icon" :color="white ? 'white' : 'orange'"
                                            :icon="mdiHomeOutline"></v-icon>
                                    <span v-else>{{ item.title }}</span>
                                </Link>
                                <v-breadcrumbs-divider class="px-3" :class="white ? 'text-white' : 'text-black'">/</v-breadcrumbs-divider>
                            </template>

                </swiper-slide>
            </swiper>
        </v-container>
    </div>
</template>

<script setup>
import {mdiHomeOutline} from "@mdi/js";
import {Link, router} from "@inertiajs/vue3";
import {computed} from "vue";
import {SwiperSlide, Swiper} from "swiper/vue";
import {VFadeTransition} from "vuetify/components";

const props = defineProps({
    items: Array,
    white: Boolean,
})
const breadcrumbs = computed(() => {
    const crumb = [];
    let last = 0;
    props.items.forEach((item, index) => {
        crumb[index] = {
            ...item
        };
        crumb[index].disabled = false;
        last = index;
    });
    crumb[last].disabled = true;
    return crumb;
})
</script>

<style scoped lang="scss">
#homepage-icon {
    font-size: 1.2em;
}
.hoverable-breadcrumb:hover {
    background-color: rgba(0, 0, 0, 0.05);
    padding: 5px 7px;
    margin: -5px -7px;
    border-radius: 5px;
}
</style>
